module.exports = "# Assembly  Overview\r\n\r\n&nbsp;\r\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/00_prep/level1_prep.md
// module id = 1518
// module chunks = 2